__turbopack_context__.v({
  "container": "EndlessAutoScrollCarousel-module__7-IU5q__container",
  "slide": "EndlessAutoScrollCarousel-module__7-IU5q__slide",
  "viewport": "EndlessAutoScrollCarousel-module__7-IU5q__viewport",
  "wrapper": "EndlessAutoScrollCarousel-module__7-IU5q__wrapper",
});
